import React, { FC } from 'react';
import './CreateButton.css';
import { FaPlusCircle } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface CreateButtonProps {
	onClick: () => void;
	label?: string;
	tooltip? : string
}

const CreateButton: FC<CreateButtonProps> = ({ label = "Créer", onClick, tooltip = "Bouton de Création de contenu" }) => (
	<ActionButton
		icon={<FaPlusCircle />}
		label={label}
		onClick={onClick}
		showLabel
	/>
);

export default CreateButton;
